import React, { useContext, useState } from 'react';
import {
  Box,
  Button,
  FormField,
  Modal,
  SpaceBetween,
  Textarea,
  TextContent,
} from '@cloudscape-design/components';
import { useApprovalDecision } from 'src/hooks/useApprovalDecision';
import { OperatorModalContext } from 'src/context/operatorModalContext';
import { PermissionAwareButton } from 'src/components/PermissionAwareButton';

export const ApprovalDecisionModal = () => {
  const { approvalConfig, setApprovalConfig } =
    useContext(OperatorModalContext);
  const [approvalLoading, sendApprovalDecision] = useApprovalDecision();
  const [statusText, setStatusText] = useState<string>('');
  if (!approvalConfig) return null;

  const onClose = () => {
    setStatusText('');
    setApprovalConfig(null);
  };

  return (
    <Modal
      header="Approval Operator"
      visible={true}
      onDismiss={onClose}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onClose}>
              Cancel
            </Button>
            <PermissionAwareButton
              requiredPermission="READ_AND_LIMITED_ACTION"
              actionDescription="reject approval operators"
              variant="normal"
              loading={approvalLoading}
              onClick={() => {
                approvalConfig.decision = 'FAILED';
                approvalConfig.statusMessage = statusText;
                sendApprovalDecision(approvalConfig, onClose);
              }}
            >
              Reject
            </PermissionAwareButton>
            <PermissionAwareButton
              requiredPermission="READ_AND_LIMITED_ACTION"
              actionDescription="approve operators"
              variant="primary"
              loading={approvalLoading}
              onClick={() => {
                approvalConfig.decision = 'SUCCEEDED';
                approvalConfig.statusMessage = statusText;
                sendApprovalDecision(approvalConfig, onClose);
              }}
            >
              Approve
            </PermissionAwareButton>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <TextContent>
          <p>
            This will either approve or reject the operator:{' '}
            <strong>{approvalConfig.operatorName}</strong>. The status message
            will be logged in either case.
          </p>
        </TextContent>
        <FormField label="Status Message (optional)">
          <Textarea
            placeholder="Enter text to be submitted with your decision."
            value={statusText}
            onChange={({ detail }) => setStatusText(detail.value)}
            rows={3}
          />
        </FormField>
      </SpaceBetween>
    </Modal>
  );
};
